<template>
  <mm-tab-title>
      <div>
      <el-form ref="form" size="small" label-width="200px">
          <el-form-item label="Account" prop="token">
            <mm-dict-select v-model="afForm.otpauthMigration" dictType="afSecret" style="width:300px;"></mm-dict-select>
          </el-form-item>
          <el-form-item label="">
            <div>
              <el-button slot="save" size="medium" type="primary" @click="submit">Get Code</el-button>
            </div>
          </el-form-item>
      </el-form>

      </div>
  </mm-tab-title>


</template>

<script>
import { TOTPGenerator } from '@/lib/TOTPGenerator.js';
export default {
data() {
  return {
    afForm: {
      otpauthMigration: '',
    },
  };
},
methods: {
  async submit() {
    if (!this.afForm.otpauthMigration) {
      this.$message.error('Please select an account.');
      return;
    }
    const code = await TOTPGenerator.generate(this.afForm.otpauthMigration);
    await this.$copyText(String(code));
    this.$message.success(`Current Code: ${code}, copy success`);
  },
},
};
</script>